module.exports = __webpack_public_path__ + "static/logo-jubii-25-022a97535a4daecb5e96106259850e98.svg";